// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cursor"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17.8237 9.34379L4.74219 4.7476L9.33838 17.8291L11.99 14.1168L17.8237 19.9504L19.945 17.8291L14.1114 11.9954L17.8237 9.34379Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.8237 9.34375L4.74219 4.74756L9.33838 17.829L11.99 14.1167L17.8237 19.9504L19.945 17.829L14.1114 11.9954L17.8237 9.34375Z","fillRule":"evenodd","strokeWidth":"props.strokeWidth","clipRule":"evenodd"}}]}]};

const CursorIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cursor',
    ref,
    icon: element,
  },
));

CursorIcon.displayName = 'CursorIcon';

export default CursorIcon;
